import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/hermes/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { hermesBaseQuery } from './baseQuery';

const FIVE_MINUTES = 5 * 60;

export const HERMES_API_REDUCER_PATH = 'api/hermes' as const;

export const hermesApiRoot = createApi({
  reducerPath: HERMES_API_REDUCER_PATH,
  baseQuery: hermesBaseQuery,
  keepUnusedDataFor: FIVE_MINUTES,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
